import { lazyWithRetry } from "utils/lazy-with-retry";
import { FEATURE_FLAGS } from "config/feature-flags";
import Home from "components/home";

const ROUTE_TYPES = {
  PUBLIC: "public",
  PROTECTED: "protected",
  AUTH: "auth",
};

// Component imports with layouts grouping
const routes = {
  blankLayout: [
    {
      path: "*",
      element: lazyWithRetry(() => import("components/not-found")),
      isProtected: false,
    },
    {
      path: "/404",
      element: lazyWithRetry(() => import("components/not-found")),
      isProtected: false,
    },
  ],
  defaultLayout: [
    {
      // Eagerly imported so the LCP banner img renders without waiting for a lazy chunk
      path: "/",
      element: Home,
      isProtected: false,
    },
    {
      path: "/register",
      element: lazyWithRetry(() => import("components/register")),
      isProtected: false,
    },
    {
      path: "/login",
      element: lazyWithRetry(() => import("components/login")),
      isProtected: false,
    },
    {
      path: "/profileedit",
      element: lazyWithRetry(() => import("view/profile/edit")),
      isProtected: true,
    },
    {
      path: "/forgetpassword",
      element: lazyWithRetry(() => import("components/forget-password")),
      isProtected: false,
    },
    {
      path: "/search-profiles",
      element: lazyWithRetry(() => import("view/search-profile")),
      isProtected: true,
    },
    {
      path: "/members/:id",
      element: lazyWithRetry(() => import("view/members/members-pages")),
      isProtected: true,
    },
    {
      path: "/terms",
      element: lazyWithRetry(() => import("components/terms")),
      isProtected: false,
    },
    {
      path: "/privacy-policy",
      element: lazyWithRetry(() => import("components/privacy-policy")),
      isProtected: false,
    },
    {
      path: "/cookie-policy",
      element: lazyWithRetry(() => import("components/cookie-policy")),
      isProtected: false,
    },
    ...(FEATURE_FLAGS.ENABLE_PREFERENCE
      ? [
          {
            path: "/preference",
            element: lazyWithRetry(() =>
              import("view/preference/preference-pages")
            ),
            isProtected: true,
          },
        ]
      : []),
    {
      path: "/resetPassword/:token",
      element: lazyWithRetry(() => import("components/reset-password")),
      isProtected: false,
    },
    {
      path: "/emailVerification/:token",
      element: lazyWithRetry(() => import("components/email-verify")),
      isProtected: true,
    },
    {
      path: "/contact-us",
      element: lazyWithRetry(() => import("view/contact-us/contact-us")),
      isProtected: false,
    },
    {
      path: "/about-us",
      element: lazyWithRetry(() => import("view/about-us")),
      isProtected: false,
    },
    {
      path: "/nakshatra-rashi-list",
      element: lazyWithRetry(() => import("view/nakshatra-rashi-list")),
      isProtected: false,
    },
    {
      path: "/quick-upload",
      element: lazyWithRetry(() => import("view/quick-upload")),
      isProtected: false,
    },
    {
      path: "/gotralu",
      element: lazyWithRetry(() => import("components/gotralu/gotralu")),
      isProtected: false,
    },
    // Commented routes for future implementation
    // { path: "/counter", component: lazyWithRetry(() => import("components/counter")), isProtected: false },
    // { path: "/verify", component: lazyWithRetry(() => import("components/verification/verification")), isProtected: false },
    // { path: "/settings", component: lazyWithRetry(() => import("components/settings")), isProtected: false },
    { path: "/account", element: lazyWithRetry(() => import("view/account/information")), isProtected: true },
    // { path: "/change-password", component: lazyWithRetry(() => import("view/account/change-password")), isProtected: false },
  ],
};

export { ROUTE_TYPES };
export default routes;
